const BASE_URL = "https://api.imageresizer.io/v1";

export const convertSvgToPng = async (svgFile) => {
  const svgMarkup = await svgFile.text();
  const svgBlob = new Blob([svgMarkup], { type: "image/svg+xml" });
  const svgUrl = URL.createObjectURL(svgBlob);

  const imageElement = new Image();
  imageElement.src = svgUrl;

  await new Promise((resolve) => {
    imageElement.onload = resolve;
  });

  const { width: imageWidth, height: imageHeight } = imageElement;

  const canvasElement = document.createElement("canvas");
  canvasElement.width = imageWidth || 512;
  canvasElement.height = imageHeight || 512;

  const canvasContext = canvasElement.getContext("2d");
  canvasContext.drawImage(imageElement, 0, 0);
  URL.revokeObjectURL(svgUrl);

  const pngBlob = await new Promise((resolve) =>
    canvasElement.toBlob((blob) => resolve(blob), "image/png")
  );

  return pngBlob;
};

export const uploadImageToImageResizerIo = async (image) => {
  const headers = {
    "Content-Type": "application/octet-stream",
  };

  const processedImage =
    image.type === "image/svg+xml" ? await convertSvgToPng(image) : image;

  try {
    const response = await fetch(
      `${BASE_URL}/images?key=${process.env.REACT_APP_IMAGE_RESIZER_API_KEY}`,
      {
        method: "POST",
        headers: headers,
        body: processedImage,
      }
    );

    if (!response.ok) {
      throw new Error("Error uploading image to ImageResizer.io");
    }

    const data = await response.json();
    const { success, response: responseData } = data;

    return {
      success,
      imageData: responseData,
    };
  } catch (error) {
    console.error("Error uploading image to ImageResizer.io", error);
    return { error: "Error uploading image to ImageResizer io" };
  }
};

export const uploadImageData = (dbCallback) => async (image) => {
  const { error, success, imageData } = await uploadImageToImageResizerIo(
    image
  );

  if (error || !success || !imageData) {
    return;
  }

  const { id } = imageData;

  return await dbCallback(
    `https://im.ages.io/${id}?width=1280&format=jpeg&quality=50`
  );
};

export const getImageFromImageResizerIo = async (imageId) => {
  try {
    const response = await fetch(
      `${BASE_URL}/images/${imageId}?key=${process.env.REACT_APP_IMAGE_RESIZER_API_KEY}`
    );

    if (!response.ok) {
      throw new Error("Error fetching image from ImageResizer.io");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching image from ImageResizer.io", error);
    return { error: "Error fetching image from ImageResizer.io" };
  }
};
